import type { ReactNode } from 'react';

/**
 * Brand spinner ported from the Amelio - React project. Renders a rotating
 * ring around a spinning favicon logo. Use <LoaderIcon /> as an inline
 * spinner, or <OverlayLoader isLoading> to overlay it on top of content.
 */

interface LoaderIconProps {
    iconImage?: string;
    className?: string;
}

export const LoaderIcon = ({ iconImage = '/favicon.png', className = '' }: LoaderIconProps) => (
    <div
        className={`amelio-loader ${className}`}
        data-testid={'spinner'}
    >
        <div className={'amelio-loader__spinner'} />

        <img
            className={'amelio-loader__logo'}
            src={iconImage}
            alt={'loading'}
            data-cy={'overlay-loader-icon'}
        />
    </div>
);

interface OverlayLoaderProps {
    isLoading: boolean;
    children?: ReactNode;
    className?: string;
    iconImage?: string;
}

export const OverlayLoader = ({
    isLoading,
    children,
    className = '',
    iconImage,
}: OverlayLoaderProps) => (
    <div className={`relative w-full ${className}`}>
        {children}

        {isLoading && (
            <div className={'amelio-loader-overlay'}>
                <LoaderIcon iconImage={iconImage} />
            </div>
        )}
    </div>
);

export default OverlayLoader;
